import { ReactNode, useEffect } from "react"
import { usePage } from "@inertiajs/react"
import clsx from "clsx"
import toast, { Toaster } from "react-hot-toast"

type Flash = {
  type: "success" | "error"
  message: string
}

const RootLayout = ({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) => {
  const { flash } = usePage().props

  useEffect(() => {
    Object.entries(flash as Flash).forEach(([type, message]) =>
      toast[type](message)
    )
  }, [flash])

  return (
    <div className={clsx("flex min-h-screen max-w-screen flex-col", className)}>
      {children}
      <Toaster position="bottom-left" />
    </div>
  )
}
export default RootLayout
